import { FormRegister } from './ui/FormRegister'
import './ui/FormRegister.css'
export default FormRegister
